export default __webpack_public_path__ + "static/media/2025.77f3af72.pdf";